import * as __viteBrowserExternal from "./__vite-browser-external.js";
import { getAugmentedNamespace } from "./_commonjsHelpers.js";
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal);
export {
  require$$2 as default
};
//# sourceMappingURL=___vite-browser-external.js.map
